// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"CustomerShipping_submitButton__1m5HS"};